export const FEATURED_BUSINESSES_COLLECTION_PATH = [
  "featured-businesses",
] as const

export const getFeaturedBusinessesCollectionPath = () => [
  ...FEATURED_BUSINESSES_COLLECTION_PATH,
]

export const getFeaturedBusinessDocPath = (id: string) => [
  ...FEATURED_BUSINESSES_COLLECTION_PATH,
  id,
]

export const getFeaturedBusinessServicesPath = (id: string) => [
  ...FEATURED_BUSINESSES_COLLECTION_PATH,
  id,
  "services",
]
